import React, { useEffect } from 'react';
import './Thank_you.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

const Thank_you = () => {

    useEffect(() => {
        if (window.gtag) {
            window.gtag('event', 'conversion', {
                send_to: 'AW-17385264806/XPy9CPTw4eIbEKat-OFA',
                value: 1.0,
                currency: 'INR',
            });
        }
    }, []);

    return (
        <section className='Thank_you_sec'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-6 mx-auto'>
                        <div className='thank_you_div'>
                            <div className='thankbox'>
                                <FontAwesomeIcon className='successicon' icon={faCircleCheck} />
                                <h1 className='thankh1'>Thank You</h1>
                                <p className='mseg'>
                                    for your inquiry. Our team will get back to you shortly!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Thank_you;
